// extracted by mini-css-extract-plugin
module.exports = {"container":"appContent_container__3X68e","footerContainer":"appContent_footerContainer__1ryoJ","bg":"appContent_bg__1vNVC"};
    if(module.hot) {
      // 1745935560524
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  